import { BaseAxios, MixedAxios, throwErrorResponse } from 'src/common/services/axios';
import { flatten } from 'src/lib/axios';
import { PageResultDTO } from 'src/common/models/page';
import { mapToSpeaker, Speaker, SpeakerDTO } from 'src/common/models/speaker';
import { map } from 'ramda';
import {
  getSinglePageWithTotalResult,
  PageCriteria,
  pagedAsyncGenerator,
} from 'src/common/utils/pagedAsyncGenerator';
import { ListWrapper, unwrap } from 'src/lib/listWrapper';

import { RelatedCourseDTO } from 'src/common/models/related';
import { mapRelated } from 'src/common/services/related';

export const listSpeakersPageSize = 9;

export const speakersGenerator = pagedAsyncGenerator(
  (searchCriteria: PageCriteria) => {
    return BaseAxios.get<PageResultDTO<SpeakerDTO>>(`api/speakers`, {
      params: searchCriteria.page,
    })
      .then(flatten)
      .catch(throwErrorResponse)
      .then((data) => ({
        ...data,
        result: data.result.map(mapToSpeaker),
      }));
  },
  (result) => result.result,
);

export const getSpeakers = async ({
  pageParam = 1,
  pageSize = listSpeakersPageSize,
}: {
  pageParam?: number;
  pageSize?: number;
}): Promise<PageResultDTO<Speaker>> =>
  getSinglePageWithTotalResult(speakersGenerator, { pageParam, pageSize }, {});

export const getSpeakerById = (id: number) =>
  BaseAxios.get(`/api/speakers/${id}`).then(flatten).then(mapToSpeaker).catch(throwErrorResponse);

export const getSpeakerCourses = (speakerId: number, limit: number, isLoggedIn: boolean) => {
  const request = isLoggedIn
    ? MixedAxios.get<ListWrapper<RelatedCourseDTO>>(`/api/courses/speaker/${speakerId}`, {
        params: { limit },
      })
    : BaseAxios.get<ListWrapper<RelatedCourseDTO>>(`/api/public/courses/speaker/${speakerId}`, {
        params: { limit },
      });

  return request.then(flatten).then(unwrap).then(map(mapRelated)).catch(throwErrorResponse);
};
